<!-- <div id="appHeader">
  <nav
    class="navbar navbar-expand-lg navbar-dark navbar-absolute px-lg-3 px-md-3 px-sm-3"
  >
    <a class="navbar-brand " routerLink="/">
      <img
        src="./assets/img/logo_small.png"
        class="d-inline-block align-middle img-fluid w-25 ms-4 me-2"
        alt="brand_logo"
      />
      TILA Top up
    </a>
  </nav>
</div> -->
<app-header [showTopbar]="false"></app-header>
<div class="container-fluid">
  <div class="session-activity-container">
    <div class="row justify-content-center align-items-center">
      <div class="col-lg-4 col-md-5 col-sm-4 col-xs-12 align-self-center">
        <div class="login-blk">
          <mat-card class="p-4">
            <h4 class="form-title text-start mb-2 px-2" translate>
              pages.login.resetPassword
            </h4>

            <mat-card-content>
              <!--password input filed-->
              <form [formGroup]="resetForm" (submit)="submit()">
                <h4
                  class="form-item-label  "
                  translate
                >
                  pages.login.newPassword <span class="required">*</span>
                  <mat-hint class="float-end" #tooltip="matTooltip" matTooltipClass="tool-tips"

                  matTooltip="{{getPasswordHint()}}"

                  matTooltipPosition="right"

                  matTooltipHideDelay="1000">

                    <i

                      class="mi mi-help-outline cur-point hint-icon" color="primary"

                     

                    ></i>

                    <!-- <span translate class="translate">pages.login.showPasswordDetails</span> -->

                  </mat-hint>
                </h4>
                <mat-form-field
                  appearance="outline"
                  [color]="passwordComponentWithConfirmation.color"
                  style="width: 100%" class="mb-0"
                >
                  <mat-pass-toggle-visibility
                    #toggle
                    matSuffix
                  ></mat-pass-toggle-visibility>
                  <input class="mb-0"
                    matInput
                    #passwordWithConfirmation
                    placeholder="{{ 'pages.login.enterPassword' | translate }}"
                    [type]="toggle.type"
                    maxlength="12"
                    [formControl]="
                      passwordComponentWithConfirmation.passwordFormControl
                    "
                    placeholder="{{ 'pages.login.enterPassword' | translate }}"
                    required
                  />
                </mat-form-field>
                <!--@angular-material-extensions/password-strength's main component-->
                <mat-password-strength
                  #passwordComponentWithConfirmation
                  (onStrengthChanged)="onStrengthChanged($event)"
                  [password]="passwordWithConfirmation.value"
                >
                </mat-password-strength>
                <!--password hint-->
                <mat-hint class="float-end" aria-live="polite">
                  {{ passwordWithConfirmation.value.length }} /
                  {{ passwordComponentWithConfirmation.max }}
                </mat-hint>

                <mat-error
                  *ngIf="
                    passwordComponentWithConfirmation
                      .passwordFormControl.touched &&
                    passwordComponentWithConfirmation.passwordFormControl.hasError(
                      'required'
                    )
                  "
                >
                  Password is required
                </mat-error>
                <mat-error
                  *ngIf="
                    passwordComponentWithConfirmation
                      .passwordFormControl.touched &&
                    passwordComponentWithConfirmation.passwordFormControl.hasError(
                      'pattern'
                    )
                  "
                >
                  Password is not valid
                </mat-error>
                <h4
                  class="form-item-label mt-3 mb-0 "
                  translate
                >
                  pages.login.confirmPassword <span class="required">*</span>
                </h4>

                <!--password input field for confirmation-->
                <mat-form-field
                  appearance="outline"
                  class="mt-3"
                  style="width: 100%"
                >
                  <mat-pass-toggle-visibility
                    #toggleConfirmPassword
                    matSuffix
                  ></mat-pass-toggle-visibility>
                  <input
                    matInput
                    #passwordToConfirm
                    maxlength="12"  
                    [type]="toggleConfirmPassword.type"
                    placeholder="{{ 'pages.login.enterPassword' | translate }}"
                    [formControl]="
                      passwordComponentWithConfirmation.passwordConfirmationFormControl
                    "
                  />
                </mat-form-field>
                <!-- password hint-->
                <mat-hint class="float-end" aria-live="polite">
                  {{ passwordToConfirm.value.length }} /
                  {{ passwordComponentWithConfirmation.max }}
                </mat-hint>

                <!-- password error msgs-->
                <mat-error
                  *ngIf="
                    passwordComponentWithConfirmation
                      .passwordConfirmationFormControl.touched &&
                    passwordComponentWithConfirmation.passwordConfirmationFormControl.hasError(
                      'required'
                    )
                  "
                >
                  Password confirmation is required
                </mat-error>
                <mat-error
                  *ngIf="
                    passwordComponentWithConfirmation
                      .passwordConfirmationFormControl.touched && 
                    passwordComponentWithConfirmation.passwordConfirmationFormControl.hasError(
                      'notConfirmed'
                    ) || !passwordComponentWithConfirmation.passwordConfirmationFormControl.pristine && passwordComponentWithConfirmation.passwordFormControl.value != passwordComponentWithConfirmation.passwordConfirmationFormControl.value
                  "
                >
                  Password is not the same
                </mat-error>
                <span *ngIf="passwordComponentWithConfirmation.passwordFormControl.status == 'VALID' && passwordComponentWithConfirmation
                .passwordConfirmationFormControl.status == 'VALID' && passwordComponentWithConfirmation.passwordFormControl.value == passwordComponentWithConfirmation.passwordConfirmationFormControl.value">Password Matches <i class="mi mi-check-circle small-icon text-success"></i> </span>
                <!--Password's strength info-->
                <mat-password-strength-info
                  *ngIf="showDetails"
                  [passwordComponent]="passwordComponentWithConfirmation"
                >
                </mat-password-strength-info>
                <button
                  mat-raised-button
                  [disabled]="passwordComponentWithConfirmation.passwordFormControl.value != passwordComponentWithConfirmation.passwordConfirmationFormControl.value"
                  color="primary"
                  type="submit"
                  class="d-block mx-auto my-4 py-2 w-100"
                >
                  <span translate class="translate">pages.login.resetPassword</span>
                </button>
              </form>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
